import { Behavior, BehaviorConfig } from './Behavior';
import { Entity } from '../base/Entity';
import type { CollisionSystem } from '../../systems/CollisionSystem';

export interface SolidConfig extends BehaviorConfig {
  // Future options: blocksProjectiles, blocksTractor, etc.
}

/**
 * SolidBehavior - Makes an Entity solid and immovable
 *
 * - Registers state.behaviors.solid = {} (presence = solid)
 * - Configures physics: immovable, no gravity
 * - Registers in CollisionSystem.solidEntities
 * - Blocks tractor beam (emits event)
 * - Unregisters on destroy
 */
export class SolidBehavior extends Behavior {
  constructor(entity: Entity, config: SolidConfig = {}) {
    super(entity, config);

    // Register state in entity.state.behaviors (namespaced pattern)
    // Presence of solid namespace = entity is solid
    this.entity.state.behaviors.solid = {};

    this.setupPhysics();
    this.registerInCollisionSystem();
  }

  private setupPhysics(): void {
    const body = this.entity.body as Phaser.Physics.Arcade.Body;
    if (body) {
      body.setImmovable(true);
      body.setAllowGravity(false);
    }
  }

  private registerInCollisionSystem(): void {
    const collisionSystem = this.scene.registry.get('collisionSystem') as CollisionSystem | undefined;
    if (!collisionSystem) {
      console.error('[SolidBehavior] CollisionSystem not found in registry');
      return;
    }
    collisionSystem.registerSolid(this.entity);
    this.scene.events.emit('tractorBlockerAdded', this.entity);
  }

  override destroy(): void {
    // Clean up state by removing namespace
    delete this.entity.state.behaviors.solid;

    const collisionSystem = this.scene.registry.get('collisionSystem') as CollisionSystem | undefined;
    if (!collisionSystem) {
      console.error('[SolidBehavior] CollisionSystem not found in registry during destroy');
      super.destroy();
      return;
    }
    collisionSystem.unregisterSolid(this.entity);
    this.scene.events.emit('tractorBlockerRemoved', this.entity);
    super.destroy();
  }
}
